import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import classes from '@nerdwallet/base-styles/classes';

import { Button, Type, Text } from '@nerdwallet/currency';
import { useImpression } from '@nerdwallet/analytics/react/impression';

const SmorgasbordTile = ({
  backgroundColor,
  textColor,
  entityName,
  eyebrow,
  eyebrowColor,
  description,
  buttonText,
  buttonUrl,
  index,
}) => {
  const tileWrapper = {
    backgroundColor: backgroundColor && `${backgroundColor}`,
    color: textColor && `${textColor}`,
  };

  const { ref } = useImpression({
    eventType: 'element_impression',
    entityName,
    payload: {
      element_position: index - 1,
      section_name: 'smorgasboard_guides',
    },
  });
  const onclick = () => {
    /**
     * TLDR: workaround to fix double click to open an anchor link inside carousel
     * https://github.com/akiran/react-slick/issues/1783
     *
     * Breakdown: react-slick (used by Carousel) is not registering the first click
     * on mobile swipes. On mobile, when the carousel "slides" tiles are set to
     * `clickable = false`. After swiping, the first click on a tile is registered,
     * and the tile is then set to "clickable" Once clickable, a second click event
     * is then able to reach the anchor tag. Two clicks to open a link.
     * */
    window.location = buttonUrl; // current workaround while the bug described above exists
  };

  return (
    <div
      ref={ref}
      style={tileWrapper}
      className={classNames([
        'smorga__tile',
        classes('margin-right-3'),
        classes('margin-right-0--wide'),
        classes('border-radius-1'),
      ])}
    >
      <div
        className={classNames([
          'smorga__content',
          classes('padding-vertical-5'),
          classes('margin-horizontal-5'),
          classes('display-flex'),
          classes('flex-direction-column'),
          classes('justify-content-center'),
          classes('height-100'),
        ])}
      >
        {eyebrow && (
          <Type
            color={eyebrowColor}
            uppercase
            size="1"
            bold
            className={classNames([
              'smorga__eyebrow',
              classes('margin-bottom-3'),
            ])}
          >
            {eyebrow}
          </Type>
        )}
        {description &&
          (index === 1 ? (
            <Type gotham size="3" color={textColor}>
              {description}
            </Type>
          ) : (
            <Text size="large">{description}</Text>
          ))}
        {buttonText && (
          <div>
            <Button
              href={buttonUrl}
              onClick={onclick}
              className={classNames(['smorga__btn', classes('margin-top-4')])}
            >
              {buttonText}
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

SmorgasbordTile.propTypes = {
  backgroundColor: PropTypes.string,
  textColor: PropTypes.string,
  entityName: PropTypes.string,
  eyebrow: PropTypes.string,
  eyebrowColor: PropTypes.string,
  description: PropTypes.string,
  buttonText: PropTypes.string,
  buttonUrl: PropTypes.string,
  index: PropTypes.number,
};

SmorgasbordTile.displayName = 'SmorgasbordTile';

export default SmorgasbordTile;
